module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "shadow-sm": ""
    }
  }, [_c('h5', {
    class: ['mb-3', _vm.titleClass]
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.items), function(vehicle) {
    return _c('div', {
      key: _vm.type + '-' + vehicle.regNo,
      staticClass: "vehicle-mini-item d-flex align-items-center mb-3"
    }, [_c('div', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      class: ['vehicle-avatar mr-3', _vm.avatarClass],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View Technical Details"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$emit('open-master-details', vehicle)
        }
      }
    }, [_c('md-icon', [_vm._v(_vm._s(_vm.icon))])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-1"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('a', {
      staticClass: "font-weight-bold text-primary vehicle-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.$emit('select-vehicle', vehicle.regNo)
        }
      }
    }, [_vm._v("\n          " + _vm._s(vehicle.regNo) + "\n        ")]), _vm._v(" "), _c('span', {
      class: ['small font-weight-bold', _vm.textClass]
    }, [_vm._v("\n          " + _vm._s(_vm.type === 'most-used' ? ((vehicle.trips) + " Trips | " + (vehicle.performance) + "%") : ("Idle " + (vehicle.idleDays) + " Days")) + "\n        ")])]), _vm._v(" "), (_vm.type === 'most-used') ? _c('b-progress', {
      staticClass: "mt-1",
      attrs: {
        "value": vehicle.performance,
        "variant": "primary",
        "height": "6px"
      }
    }) : _c('div', {
      staticClass: "text-muted xs-font"
    }, [_vm._v("\n        Last active: " + _vm._s(vehicle.lastActive) + "\n        "), (vehicle.grnNo || vehicle.assignmentNo) ? _c('div', {
      staticClass: "mt-1"
    }, [(vehicle.grnNo) ? _c('b-badge', {
      staticClass: "mr-1 text-dark border",
      attrs: {
        "variant": "light"
      }
    }, [_vm._v("GRN: " + _vm._s(vehicle.grnNo))]) : _vm._e(), _vm._v(" "), (vehicle.assignmentNo) ? _c('b-badge', {
      staticClass: "text-dark border",
      attrs: {
        "variant": "light"
      }
    }, [_vm._v("ASG: " + _vm._s(vehicle.assignmentNo))]) : _vm._e()], 1) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-3"
  }, [_c('b-button', {
    staticClass: "p-0 small",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        _vm.$emit('view-all')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.type === 'idle' ? 'View All Idle' : 'View Full Ranking') + "\n    ")]), _vm._v(" "), (_vm.type === 'idle') ? _c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "pill": ""
    }
  }, [_vm._v("\n      Alert Fleet Manager\n    ")]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45974688","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/VehicleMiniList.vue
// module id = 2571
// module chunks = 0